import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './Components/Header.jsx';
import NewsDetails from './Pages/NewsDetails';
import Logo from './Components/Logo';
import Navbar from './Components/Navbar';
import NewsGrid from './Components/NewsGrid';
import Login from './Components/Login';
import AdminDashboard from './Components/AdminDashboard';
import NewsEditor from './Components/NewsEditor';
import CategoryPage from './Components/CategoryPage';
import { SearchProvider } from './SearchContext';
import LatestSidebar from './Components/LatestSidebar';
import Footer from './Components/Footer';
import MobileHeader from './Components/MobileHeader';
import MobileCategoryPage from './Components/MobileCategoryPage';
import MobileNewsDetails from './Components/MobileNewsDetails';
import AjkerPatrika from './Components/TodayPaperManager'; 
import EPaper from './Components/EPaperManager';
import Magazine from './Components/MagazineManager';
import { doc, setDoc, increment } from "firebase/firestore";
import { db } from "./firebaseConfig";
import TagPage from "./Pages/TagPage";
import FooterPage from "./Pages/FooterPage";
import ScrollToTop from "./Components/ScrollToTop";
import EditorialPanel from "./Pages/EditorialPanel";
import Archive from "./Components/Archive";
import Search from "./Pages/Search";
import Video from "./Pages/Video";
import VideoDetails from "./Pages/VideoDetails";
import PhotoGallery from "./Components/PhotoGallery";
import PhotoDetails from "./Components/PhotoDetails";
import AudioGallery from "./Components/AudioGallery";

const GlobalStyles = () => (
  <style>{`
    /* ভার্টিকাল স্ক্রলবার */
    ::-webkit-scrollbar { width: 6px; height: 8px; }
    
    /* স্ক্রলবারের ট্র্যাক */
    ::-webkit-scrollbar-track { background: #f1f1f1; }
    
    /* স্ক্রলবারের থাম্ব */
    ::-webkit-scrollbar-thumb { 
      background: #a9a9a9; 
      border-radius: 10px; 
    }
    
    /* মাউস নিলে রঙ পরিবর্তন */
    ::-webkit-scrollbar-thumb:hover { background: #888; }
  `}</style>
);

function AppLayout() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const location = useLocation();
  
  // কন্ডিশন: যদি অ্যাডমিন বা লগইন পেজ হয়
  const hideHeaderFooter = location.pathname === '/admin' || location.pathname === '/login' || location.pathname === '/publish';

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
 useEffect(() => {
  const visit = async () => {
    const path = location.pathname;

    // Admin page count হবে না
    if (
      path === "/admin" ||
      path === "/login" ||
      path === "/publish"
    ) {
      return;
    }

    const key = "visit-" + new Date().toDateString();

    // একই browser session-এ একবারই count
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");

    const now = new Date();

    const today =
      now.getFullYear() +
      "-" +
      String(now.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(now.getDate()).padStart(2, "0");

    try {
      await setDoc(
        doc(db, "site_stats", "visitors"),
        {
          total: increment(1),
          [today]: increment(1),
        },
        { merge: true }
      );

      console.log("Visitor saved");
    } catch (err) {
      console.error("Visitor Error:", err);
    }
  };

  visit();
}, [location.pathname]);

  const ProtectedRoute = ({ children }) => {
  // এখানে আপনার লগইন স্ট্যাটাস চেক করুন (যেমন: localStorage বা Context)
  const isAuthenticated = localStorage.getItem("isAdminLoggedIn"); // উদাহরণস্বরূপ
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return children;
};
  
  
  
  
  return (
<div className="app-container" style={{ overflow: 'visible', display: 'flex', flexDirection: 'column' }}>
   {/* হেডার হাইড করার কন্ডিশন */}
      {!hideHeaderFooter && (
        <>
          {isMobile ? (
            <MobileHeader />
          ) : (
            <>
    
        <div style={{ 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'flex-start', // সব বামে চলে আসবে
  width: '100%' 
}}>
   <div style={{ marginRight: '50px' }}> {/* লোগোর জন্য একটা নির্দিষ্ট মার্জিন */}
      <Logo />
   </div>
   
   <div style={{ flexGrow: 1 }}> {/* হেডার জায়গা দখল করবে */}
      <Header />
   </div>
</div>
        <Navbar />
      </>
    )}
  </>
)}

      <main
  style={{
    marginTop: 0,
    minHeight: "calc(100vh - 200px)",
    paddingLeft: "10px",
    paddingRight: "10px",
  }}
>


  <ScrollToTop />
        <Routes>
  <Route path="/search" element={<Search />} />
	   
	  <Route 
    path="/:categorySlug/:subcategorySlug/:id" 
    element={isMobile ? <MobileNewsDetails /> : <NewsDetails />} 
  /> 
	   
 <Route path="/login" element={<Login />} />
        
  <Route 
    path="/admin" 
    element={
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    } 
  />
         <Route 
    path="/publish" 
    element={
      <ProtectedRoute>
        <NewsEditor />
      </ProtectedRoute>
    } 
  />
	<Route path="/ajker-patrika" element={<AjkerPatrika />} />
  <Route path="/e-paper" element={<EPaper />} />
  <Route path="/magazine" element={<Magazine />} />	 
<Route path="/archive" element={<Archive />} />  
<Route path="/video" element={<Video />} />
<Route path="/video/:id" element={<VideoDetails />} />
<Route path="/photos" element={<PhotoGallery />} />
<Route path="/photo/:id" element={<PhotoDetails />} />
<Route path="/audio" element={<AudioGallery />} />
<Route 
    path="/category/:categoryName/:subcategory"
    element={isMobile ? <MobileCategoryPage /> : <CategoryPage />}
  />
 
<Route path="/page/:pageId" element={<FooterPage />} />
<Route path="/editorial-panel" element={<EditorialPanel />} />
 <Route path="/tag/:tag/*" element={<TagPage />} />
  <Route 
    path="/category/:categoryName"
    element={isMobile ? <MobileCategoryPage /> : <CategoryPage />}
  />
          <Route path="/" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 10px' }}>
              <div style={{ borderLeft: '5px solid #d2202a', paddingLeft: '15px', margin: '0' }}>
                <h2 style={{ fontSize: '25px', fontWeight: 'bold', color: '#333', margin: '0' }}>সর্বশেষ খবর</h2>
              </div>
			  
             <div
  style={{
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
	alignItems: 'flex-start',
    gap: '20px',
    marginTop: '20px'
  }}
>
  <div style={{ flex: 3,  minWidth: 0 }}>
    <NewsGrid category="all" layout="grid" />
  </div>

  {!isMobile && (
 <aside
  style={{
    flex: 1,
    minWidth: 320
  }}
>
      <LatestSidebar />
    </aside>
  )}
              </div>
            </div>
          } />
        </Routes>
		
      </main>
	  {!hideHeaderFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <SearchProvider>
      <GlobalStyles />
      <Router>
        <AppLayout />
      </Router>
    </SearchProvider>
  );
}



export default App;
